import { Chip, Division, Flex, Heading, Icon, Icons, Paragraph } from "@ir/ui";

export interface BrandDetailsAccountingIntegrationHeaderProps {
  connected: boolean;
  statusLoading?: boolean;
  systemName?: string | null;
}

export const BrandDetailsAccountingIntegrationHeader = ({
  connected,
  statusLoading = false,
  systemName = null,
}: BrandDetailsAccountingIntegrationHeaderProps) => {
  const label = statusLoading
    ? "Checking..."
    : connected
      ? "Connected"
      : "Disconnected";
  const color = connected && !statusLoading ? "success" : "warning";
  const subtitle = systemName
    ? `Manage your connection with ${systemName}`
    : "Manage your accounting system connection";

  return (
    <Flex align="center" justifyContent="space-between" gap={2} direction="row">
      <Flex align="center" gap={1} direction="row">
        <Division
          style={{
            width: 40,
            height: 40,
            borderRadius: 10,
            background: "rgba(33, 104, 105, 0.12)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <Icon name={Icons.Calculator01} color="primary" />
        </Division>
        <Division style={{ minWidth: 0 }}>
          <Heading level={6} className="text-grey-700 font-bold m-0">
            Accounting System Integration
          </Heading>
          <Paragraph
            className="text-grey-500 font-regular m-0"
            style={{ fontSize: "0.8rem" }}
          >
            {subtitle}
          </Paragraph>
        </Division>
      </Flex>
      <Chip
        size="small"
        label={label}
        color={color}
        borderless
      />
    </Flex>
  );
};
